import { loadBlockComponent } from './component';
import { loadBlock } from './block';

const initBlock = (editor, opts = {}) => {
  const defaults = {
    componentType: 'Block',
    blockCategory: 'React Components',
    label: 'Block',
  };

  const options = { ...defaults, ...opts };

  loadBlockComponent(editor, options);
  loadBlock(editor, options);
};

export default initBlock;
